import {
  SURVEY_LOADING,
  GET_SURVEY,
  GET_SURVEY_SUCCESS,
  GET_SURVEY_FAIL,
  ADD_SURVEY_SUCCESS,
  ADD_SURVEY_FAIL,
  DELETE_SURVEY_SUCCESS,
  DELETE_SURVEY_FAIL,
  UPDATE_SURVEY_SUCCESS,
  UPDATE_SURVEY_FAIL,
  SURVEY_RESET,
} from "./actionType";

const INIT_STATE = {
  surveys: [],
  error: {},
};

const Survey = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SURVEY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SURVEY:
          return {
            ...state,
            surveys: action.payload.data,
            isSurveyCreated: false,
            isSurveySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SURVEY_FAIL:
      switch (action.payload.actionType) {
        case GET_SURVEY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSurveyCreated: false,
            isSurveySuccess: false,
            loading: false,
          };
        default:
          return { ...state, loading: false };
      }

    case GET_SURVEY: {
      return {
        ...state,
        isSurveyCreated: false,
        loading: true,
      };
    }

    case SURVEY_LOADING: {
      return {
        ...state,
        isSurveyCreated: false,
        loading: true,
      };
    }

    case ADD_SURVEY_SUCCESS:
      return {
        ...state,
        isSurveyCreated: true,
        loading: false,
        surveys: [action.payload.data, ...state.surveys],
      };

    case ADD_SURVEY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SURVEY_SUCCESS:
      return {
        ...state,
        loading: false,
        surveys: state.surveys.filter(
          (survey) => survey.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SURVEY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SURVEY_SUCCESS:
      return {
        ...state,
        loading: false,
        surveys: state.surveys.map((survey) =>
          survey.id.toString() === action.payload.data.id.toString()
            ? { ...survey, ...action.payload.data }
            : survey
        ),
      };

    case UPDATE_SURVEY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SURVEY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Survey;
